import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, Link } from 'react-router-dom';

import './App.css';

// Layout Components
import Navbar from './components/navbar';
import Footer from './components/footer';
import Loader from './components/Loader';
import ScrollToTop from './components/ScroollToTop';

// Page Components
import Home from './components/home';
import AboutUs from './components/AboutUs';
import LivingRoom from './components/livingroom';
import Cafe from './components/cafe';
import Bedroom from './components/bedroom';
import Restaurant from './components/restaurant';
import Bar from './components/bar';
import ContactPage from './components/ContactPage';

// Product Components
import CollectionPage from './components/products/CollectionPage';

function App() {
  const [showLoader, setShowLoader] = useState(true);

  const handleLoadComplete = () => {
    setShowLoader(false);
  };

  return (
    <>
      {showLoader && <Loader onLoadComplete={handleLoadComplete} />}
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />

      <div className="app">
        <Routes>
          {/* Main Routes */}
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/livingroom" element={<LivingRoom />} />
          <Route path="/living-room" element={<LivingRoom />} />
          <Route path="/cafe" element={<Cafe />} />
          <Route path="/bedroom" element={<Bedroom />} />
          <Route path="/restaurant" element={<Restaurant />} />
          <Route path="/bar" element={<Bar />} />
          <Route path="/contact" element={<ContactPage />} />

          {/* Additional Pages */}
          <Route path="/customize" element={<div className="text-center py-16"><h1 className="text-4xl font-bold">Customize Products</h1><p className="mt-4">Coming Soon</p></div>} />
          <Route path="/interior-solution" element={<div className="text-center py-16"><h1 className="text-4xl font-bold">Interior Solutions</h1><p className="mt-4">Coming Soon</p></div>} />
          <Route path="/faq" element={<div className="text-center py-16"><h1 className="text-4xl font-bold">FAQ</h1><p className="mt-4">Coming Soon</p></div>} />
          <Route path="/terms" element={<div className="text-center py-16"><h1 className="text-4xl font-bold">Terms of Service</h1><p className="mt-4">Coming Soon</p></div>} />
          <Route path="/privacy" element={<div className="text-center py-16"><h1 className="text-4xl font-bold">Privacy Policy</h1><p className="mt-4">Coming Soon</p></div>} />

          {/* Dynamic Category Collection Routes */}
          <Route path="/livingroom/:category" element={<CollectionPage />} />
          <Route path="/living-room/:category" element={<CollectionPage />} />
          <Route path="/restaurant/:category" element={<CollectionPage />} />
          <Route path="/bar/:category" element={<CollectionPage />} />
          <Route path="/cafe/:category" element={<CollectionPage />} />
          <Route path="/bedroom/:category" element={<CollectionPage />} />



          {/* 404 Page */}
          <Route
            path="*"
            element={
              <div className="text-center py-16">
                <h1 className="text-4xl font-bold text-gray-800">404 - Page Not Found</h1>
                <p className="text-lg text-gray-600 mt-4">The page you are looking for does not exist.</p>
                <Link to="/" className="mt-8 inline-block text-blue-600 hover:underline">Go to Home</Link>
              </div>
            }
          />
        </Routes>
      </div>

      <Footer />
    </BrowserRouter>
    </>
  );
}

export default App;
